export const agGridTableMessages = {
	MSG_NO_DATA_TITLE: 'Atenção',
	MSG_NO_DATA_DESCRIPTION: 'Não há dados para exibir.',

	MSX_SHOW_ZERO_HIERARCHY_COMBINATIONS:
		'Exibir combinações hierárquicas zeradas',
	MSX_HIDE_ZERO_HIERARCHY_COMBINATIONS:
		'Ocultar combinações hierárquicas zeradas',
};
